import { Actions } from './components/actions'
import { AdditionalCriteria } from './components/additional-criteria'
import { Conditions } from './components/conditions'
import { Scope } from './components/scope'
import { RuleSummaryProps } from './types'

export const RuleSummary = ({
	rule,
	targetName,
	level,
	platform,
	direction= 'flex flex-col',
	dirContainer = 'flex flex-col items-start gap-2',
															titleClass,
}: RuleSummaryProps) => {
	const containerId = `rule-summary-${rule.id || 'create'}`

	return (
		<div
			id={containerId}
			className={` gap-4 2xl:flex-row 2xl:gap-8 ${direction}`}
		>
			<div className={`${dirContainer }`}>
				<Scope
					rule={rule}
					targetName={targetName}
					level={level}
					platform={platform}
					titleClass={titleClass}
				/>
				<Conditions trigger={rule.trigger} titleClass={titleClass} />
				{rule.modifiers.length > 0 && (
					<AdditionalCriteria
						modifiers={rule.modifiers}
						threshold={rule.threshold}
						titleClass={titleClass}
					/>
				)}
			</div>
			<Actions rule={rule}  titleClass={titleClass}/>
		</div>
	)
}
